import { render, staticRenderFns } from "./WorkDays.vue?vue&type=template&id=6a19e156&scoped=true"
import script from "./WorkDays.vue?vue&type=script&lang=js"
export * from "./WorkDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19e156",
  null
  
)

export default component.exports